export default __webpack_public_path__ + "assets/images/peergame-light-9967e1f77c05a57b6ad3fe36f5ab3fb7.svg";